// extracted by mini-css-extract-plugin
export var errorIcon = "_pw-1";
export var nameLogo = "_pw-0";